module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "col-md-9 margin-left-14",
    on: {
      "click": _vm.navigatoToCertificate
    }
  }, [(_vm.certificate.typeAlert === 'certificate-received') ? _c('a', [_vm._v(" Consulta " + _vm._s(_vm.getName(this.certificate.certificateName)) + " do cliente " + _vm._s(this.certificate.name) + " esta pronta  "), _c('i', {
    staticClass: "fa fa-check text-success"
  })]) : _vm._e(), _vm._v(" "), (_vm.certificate.typeAlert === 'certificate-creation-failed') ? _c('a', [_vm._v(" Houve um erro ao consultar a cerdidão " + _vm._s(_vm.getName(this.certificate.certificateName)) + " para o cliente. Por favor tente novamente " + _vm._s(this.certificate.name) + " "), _c('i', {
    staticClass: "fa fa-check text-success"
  })]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "space-50"
  }), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("time")(this.certificate.date)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29e0f4d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/general_notification_components/CertificateReadyNotification.vue
// module id = 798
// module chunks = 2